module.exports = __webpack_public_path__ + "static/media/_british-antarctic-territory.77efa0bd.png";